export default "__VITE_ASSET__Yg4eLx91__"